import { SlideLayout } from '@gripp/shared-ui';
import { useNavigate } from 'react-router-dom';
import { useWindowDimensions } from '../../shared/hooks/useWindowDimensions';
import { RoutineFold } from './routineFold';

export const Routines = ({
  rightColumn,
  viewMode,
}: {
  rightColumn?: any;
  viewMode?: any;
}) => {
  const navigate = useNavigate();
  const windowDimensions = useWindowDimensions();
  const maxHeight = (windowDimensions?.height ?? 0) - 185; // substract banner + padding height

  const onRoutineSelected = (row: any) => {
    navigate(`/routines/${row?.routineId ?? row?.id}/preview`);
  };

  const columnComponent = (
    <RoutineFold maxHeight={maxHeight} onRoutineSelected={onRoutineSelected} />
  );

  return (
    <SlideLayout
      leftColumn={{
        title: 'assets.list.routines',
        mainComponent: columnComponent,
      }}
      rightColumn={rightColumn}
      viewMode={viewMode}
    />
  );
};
